import React from "react";
import { Box, Typography, Divider, Accordion, AccordionDetails, AccordionSummary, CircularProgress } from "@mui/material";
import ReactMarkdown from "react-markdown";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";


const StyledAccordion = styled(Accordion)(() => ({
  borderRadius: "25px",
  "&:first-of-type": {
    borderTopLeftRadius: "25px",
    borderTopRightRadius: "25px",
  },
  "&:last-of-type": {
    borderBottomLeftRadius: "25px",
    borderBottomRightRadius: "25px",
  },
}));

const ExcerptsContainer = ({ annotations = [], isLoading = false, expandedFileRefId, setExpandedFileRefId }) => {
  return (
    <Box sx={{pb:"1vh"}}>
      <Typography variant="h6" gutterBottom>
        Sources
      </Typography>
      
      {isLoading ? (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <Box
          sx={{
            opacity: annotations.length > 0 ? 1 : 0.3,
            transition: "opacity 0.3s ease-in-out",
          }}
        >
          {annotations.length === 0 ? (
            <Typography variant="body2">No sources available.</Typography>
          ) : (
            annotations.map((annotation) => (
              <Box key={annotation.index} id={`annotation-${annotation.index}`} mb={2}>
                <StyledAccordion 
                  key={annotation.fileRefId} 
                  id={`ref-${annotation.fileRefId}`}
                  slotProps={{ heading: { component: 'h4' } }}
                  expanded={expandedFileRefId === annotation.fileRefId}
                  onChange={() =>
                    setExpandedFileRefId(prev => (prev === annotation.fileRefId ? false : annotation.fileRefId))
                  }
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      width: '100%', 
                      alignItems: 'center' 
                    }}>
                      <Typography sx={{ pr: 2, wordBreak: 'break-word', maxWidth: '90%' }}>
                        {annotation.excerptTitle}
                      </Typography>
                      <Box sx={{ 
                        flexShrink: 0, 
                        backgroundColor: '#f0f0f0', 
                        borderRadius: '4px', 
                        padding: '2px 6px',
                        fontSize: '0.875rem',
                        color: 'gray'
                      }}>
                        {annotation.fileRefId}
                      </Box>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails sx={{pt:"0px"}}>
                    <Typography color="Grey" variant="caption">Source: {annotation.document}</Typography><br />
                    <Typography color="Grey" variant="caption">Page(s): {annotation.pageReference}</Typography>
                    <Divider sx={{ mt: 1 }} />
                    <Typography variant="body2">
                      <ReactMarkdown>{annotation.excerpt}</ReactMarkdown>
                    </Typography>
                  </AccordionDetails>
                </StyledAccordion>
              </Box>
            ))
          )}
        </Box>
      )}
    </Box>
  );
};

export default ExcerptsContainer;